import React from 'react';
import { ThemeConsumer } from 'react-native-elements';
import { Text } from 'react-native';

import { useDualCurrencyExchangeRate } from '../../frontend/hooks/useDualCurrencyExchangeRate';
import { __ } from '@ampeco/i18n';

interface DualCurrencyExchangeRateProps {
  currencyId: number | undefined;
  operatorCountry?: string | null;
}

export const DualCurrencyExchangeRate: React.FC<DualCurrencyExchangeRateProps> = ({
  currencyId,
  operatorCountry,
}) => {
  const { shouldShowDualCurrencyExchangeRate } = useDualCurrencyExchangeRate({
    currencyId,
    operatorCountry
  });

  if (!shouldShowDualCurrencyExchangeRate) {
    return null;
  }

  return (
    <ThemeConsumer>
      {({ theme }) => ( 
        <Text style={theme.DualCurrencyExchangeRate.style}>
          {__('wallet.dual-currency-exchange-rate-eur-bgn')}
        </Text>
      )}
    </ThemeConsumer>
  );
};
